import ImageProxy from '@next-image-proxy';

import MagicSquareLogo from '@uikit/icons/MagicSquareLogo';

import { formatNumberLocalized } from '@shared/helpers/formatters';
import { concatCurrencyToAmount } from '@shared/helpers/web3/formatters';

import { ProgressBar } from '@ui/uikit/surrogates/ProgressBar';

interface TradingVolumeProgressProps {
  maxValue?: number;
  minValue?: number;
  value?: number;
}

const DEFAULT_MAX_VALUE = 500000;

export const TradingVolumeProgress = ({
  maxValue = DEFAULT_MAX_VALUE,
  minValue = 0,
  value = 0,
}: TradingVolumeProgressProps) => {
  const formattedValue = concatCurrencyToAmount(formatNumberLocalized(value), '$');

  return (
    <div className="relative h-[210px] w-full p-6 rounded-lg overflow-hidden story-prose-none">
      <div className="flex flex-col gap-6 relative z-[1]">
        <div className="flex gap-2.5">
          <MagicSquareLogo className="w-[82px]" />
          <div className="flex flex-col font-semibold text-base-text-white">
            <div className="text-[56px] leading-[60px] font-secondary" title={formattedValue}>
              {formattedValue}
            </div>
            <div className="text-[20px] leading-[22px] opacity-50">Current Total Volume</div>
          </div>
        </div>
        <ProgressBar
          minValue={minValue}
          maxValue={maxValue}
          value={value}
          appearance={{
            container: 'w-full',
            indicator: {
              paper: 'rounded-full',
              mask: 'rounded-l-full shadow-[0_4.72px_4.72px_rgba(0,0,0,0.57)]',
            },
          }}
          overrides={{
            '--progress-bar-height': '24px',
            '--progress-bar-paper': 'white',
            '--progress-bar-ink': 'linear-gradient(90.38deg, #8009CF 0.33%, #EE107B 96%)',
          }}
        />
      </div>
      <ImageProxy
        className="absolute inset-0 w-full h-full object-cover z-0"
        src="/store/stories/foxsy-ai-1000000-trading-competition/progressbar-background.png"
        width={1162}
        height={210}
        sizes="100vw"
        quality={100}
        alt="Foxsy.AI 1000000 trading competition — Rewards table"
      />
    </div>
  );
};
